import { render, staticRenderFns } from "./SceneDetails.vue?vue&type=template&id=64e4b33e&scoped=true"
import script from "./SceneDetails.vue?vue&type=script&lang=js"
export * from "./SceneDetails.vue?vue&type=script&lang=js"
import style0 from "./SceneDetails.vue?vue&type=style&index=0&id=64e4b33e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4b33e",
  null
  
)

export default component.exports